export const api = {
  commonAreaList: `${process.env.VUE_APP_API_PATH}/api/common/areaList`,
  parkinglotFileUpload: `${process.env.VUE_APP_API_PATH}/api/parkinglot/fileUpload`,
  parkinglotImportIparkingList: `${process.env.VUE_APP_API_PATH}/api/parkinglot/importIparkingList`,
  parkinglotListInScope: `${process.env.VUE_APP_API_PATH}/api/parkinglot/listInScope`,
  parkinglotRegisterCheck: `${process.env.VUE_APP_API_PATH}/api/parkinglot/registerCheck`,
  parkinglotDetail: `${process.env.VUE_APP_API_PATH}/api/parkinglot/detail`,
  parkinglotImportIparking: `${process.env.VUE_APP_API_PATH}/api/parkinglot/importIparking`,
  parkinglotSync: `${process.env.VUE_APP_API_PATH}/api/parkinglot/sync`,
  parkinglotAdd: `${process.env.VUE_APP_API_PATH}/api/parkinglot/add`,
  parkinglotList: `${process.env.VUE_APP_API_PATH}/api/parkinglot/v2/list`,
  signUp: `${process.env.VUE_APP_API_PATH}/api/signUp`,
  signIn: `${process.env.VUE_APP_API_PATH}/api/signIn`,
  changePassword: `${process.env.VUE_APP_API_PATH}/api/changePassword`,
  comment: `${process.env.VUE_APP_API_PATH}/api/comment`,
  sessionCheck: `${process.env.VUE_APP_API_PATH}/api/getSession`
};

export const parkinglot = {
  statistics: `${process.env.VUE_APP_API_V2_PATH}/statistics`,
  statisticsList: `${process.env.VUE_APP_API_V2_PATH}/statistics/list`
};
